import { useMemo } from "react"

import { useParams } from "react-router-dom"

import { Layer, MapStyles, ROADWORK_PAINTING_LAYER, ROADWORK_SOURCE, useMapStateContext, useOrderingLayers } from "@l2r-front/l2r-map"
import { useTheme } from "@l2r-front/l2r-ui"

import { getRoadworkTechniquesLayerStyle } from "../../constants/getRoadworkConfig"
import { useRoadworksStateContext } from "../../contexts/RoadworksContext"

import { RoadworksSource } from "../RoadworksSource"

export function RoadworkStabiloSectionLayer(props) {

    const { mapId } = props

    const theme = useTheme()
    const { getCurrentMapStyle } = useMapStateContext()
    const { filters } = useRoadworksStateContext()
    const { road } = useParams()
    const { roadworkUuid } = useParams()
    useOrderingLayers([ROADWORK_PAINTING_LAYER], mapId)

    const roadworksLayerConfig = useMemo(() => {
        const referentialColor = getCurrentMapStyle() === MapStyles.plan ? theme.palette.map.darkReferential
            : theme.palette.map.lightReferential

        return getRoadworkTechniquesLayerStyle(referentialColor, null, road, filters, theme, true, roadworkUuid)
    }, [getCurrentMapStyle, road, filters, theme, roadworkUuid])

    return <RoadworksSource id={ROADWORK_SOURCE}>
        <Layer
            {...roadworksLayerConfig}
            id={ROADWORK_PAINTING_LAYER}
            interactive={false}
        />
    </RoadworksSource>
}